import { MdOutlineArrowBackIosNew } from "react-icons/md";

export default function AddSubscriber({ setCreateNewChannelSection }) {
  return (
    <div className="w-full items-center  min-h-[67px] py-2.5 bg-white text-black flex gap-4 px-4 border-b border-[#EBEBEB]">
      <MdOutlineArrowBackIosNew
        className="border border-gray-300 p-1.5 rounded text-3xl cursor-pointer"
        onClick={() => {
          setCreateNewChannelSection(3);
        }}
      />
      <h1 className="text-lg font-semibold text-center">Add Followers</h1>
    </div>
  );
}
